import _ from 'lodash';
import fetch from 'isomorphic-fetch';
import queryString from 'query-string';
import { modal } from 'react-redux-modal';
import { push } from 'react-router-redux';
import { browserHistory } from 'react-router';
import BrowserStore from 'store2';
import { SubmissionError } from 'redux-form';
import Cookie from 'js-cookie';
import { checkHttpStatus, isSubdomain, parseJSON } from '../utils';
import { SignUpModalView } from '../components';
import {
  fetchUserFavoritesSuccess,
  resetUserFavorites
} from './favorites';
import { setAlerts } from './alerts';
import { setInitialLoad } from './globalConfig';
import { setUserPreferences } from './uiPreferences';

import {
  AUTH_LOGIN_USER_REQUEST,
  AUTH_LOGIN_USER_FAILURE,
  AUTH_LOGIN_USER_SUCCESS,
  AUTH_LOGOUT_USER,
  AUTH_SOCIAL_LOGIN_REQUEST_AND_SET_PROVIDER,
  AUTH_OPEN_SOCIAL_WINDOW,
  AUTH_HANDLE_CONFIRM_REDIRECT,
  AUTH_POST_SIGNUP_REQUEST,
  AUTH_POST_SIGNUP_FAILURE,
  AUTH_FORGOT_PASSWORD_FAILURE,
  AUTH_FORGOT_PASSWORD_SUCCESS,
  AUTH_FORGOT_PASSWORD_REQUEST,
  AUTH_ASSOCIATE_USER_REQUEST,
  AUTH_ASSOCIATE_USER_FAILURE,
  AUTH_ASSOCIATE_USER_SUCCESS,
  AUTH_DISQUS_RESET,
  AUTH_DISQUS_SET,
  AUTH_PASSWORD_RESET_REQUEST,
  AUTH_PASSWORD_RESET_FAILURE,
  AUTH_PASSWORD_RESET_SUCCESS,
  UNSET_JANRAIN,
  AUTH_SET_RESET_TOKEN,
  AUTH_CLEAR_RESET_TOKEN,
  DISABLE_REGISTRATION_PROMPT,
  AUTH_SET_ACTION,
  AUTH_SET_CAMERAS_API_TOKEN,
  AUTH_SET_SNAPSHOT_RATINGS,
  AUTH_BROADCAST_REQUEST,
  AUTH_BROADCAST_SUCCESS,
  AUTH_BROADCAST_FAILURE,
  AUTH_TEMPLATE_REQUEST,
  AUTH_TEMPLATE_SUCCESS,
  AUTH_TEMPLATE_FAILURE,
  AUTH_PLAYER_ALERT_REQUEST,
  AUTH_PLAYER_ALERT_SUCCESS,
  AUTH_PLAYER_ALERT_FAILURE,
  AUTH_DELETE_USER_REQUEST,
  AUTH_DELETE_USER_SUCCESS,
  AUTH_DELETE_USER_FAILURE, SET_GQL_TOKEN, SET_COMMENT_USER,
} from '../constants';
import ExploreAuth from '../utils/ExploreAuth';
import { currentUserSuccess } from './currentUser';
import { dataLayerGTM, initializeGTMWithEvent } from '../utils/googleTagManager';
import { eventGA, setDataGA } from '../utils/googleAnalytics';

require('es6-promise')
  .polyfill();

export function authLogout() {
  BrowserStore.session.remove('token');
  BrowserStore.session.remove('user');
  BrowserStore.session.remove('favorites');
  BrowserStore.remove('janrain');
  BrowserStore.remove('user');
  BrowserStore.remove('associate');
  BrowserStore.remove('token');
  Cookie.remove('sessionid', { path: '/' });
  BrowserStore.remove('gql_token');
  Cookie.remove('gql_token', { path: '/' });
  Cookie.remove('comment_user', { path: '/' });
  BrowserStore.remove('comment_user_info');
  return (dispatch) => {
    dispatch(resetUserFavorites());
    dispatch(setGqlToken(null));
    dispatch(disqusReset());
    dispatch(unsetJanrain());
    dispatch({ type: AUTH_LOGOUT_USER });
  };
}

export function fetchForgotPassword(formData, removeModal) {
  return (dispatch) => {
    dispatch(requestForgotPassword());
    const email = formData.email;
    return fetch(`${SERVER_URL}/auth/forgot_password`, {
      method: 'post',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: encodeURI(`email=${email}`),
    })
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        setTimeout(() => {
          removeModal();
        }, 10000);
        dispatch(forgotPasswordSuccess());
      })
      .catch((error) => {
        dispatch(forgotPasswordFailure(error.message));
        throw new SubmissionError({
          email: 'Email does not exist',
          _error: 'Error submitting form:',
        });
      });
  };
}

export function setGqlToken(token) {
  return {
    type: SET_GQL_TOKEN,
    payload: {
      gqlToken: token,
    },
  };
}
export function setCommentUser(user) {
  return {
    type: SET_COMMENT_USER,
    payload: {
      user,
    },
  };
}

export function forgotPasswordFailure(errorMessage) {
  return {
    type: AUTH_FORGOT_PASSWORD_FAILURE,
    payload: {
      error: errorMessage,
    },
  };
}

export function forgotPasswordSuccess() {
  return {
    type: AUTH_FORGOT_PASSWORD_SUCCESS,
  };
}

export function requestForgotPassword() {
  return {
    type: AUTH_FORGOT_PASSWORD_REQUEST,
  };
}

export function setAuthAction(action) {
  return {
    type: AUTH_SET_ACTION,
    payload: {
      action,
    },
  };
}

export function sendPasswordReset(formData, callback) {
  return (dispatch) => {
    const data = {
      email: formData.email,
      token: formData.token,
      password: formData.password,
      password_confirmation: formData.passwordConfirm,
    };
    dispatch(requestPasswordReset());
    return fetch(`${SERVER_URL}/auth/reset_password`, {
      method: 'post',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(passwordResetSuccess());
        if (callback) {
          callback();
        }
      })
      .catch((error) => {
        dispatch(passwordResetFailure());
        throw new SubmissionError({
          _error: 'Error submitting password reset:',
        });
      });
  };
}

export function sendChangePassword(formData, callback) {
  return (dispatch) => {
    const data = {
      password: formData.password,
      password_confirmation: formData.passwordConfirm,
    };
    dispatch(requestPasswordReset());
    return ExploreAuth.getValidJwt()
      .then((tokenIsValid) => {
        // Token can't be refreshed log them out
        if (!tokenIsValid) {
          // We should probably add a modal here informing them they need to log back in.
          dispatch(authLogout());
        }
        return fetch(`${SERVER_URL}/accounts/password`, {
          method: 'post',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${ExploreAuth.getJwt()}`,
          },
          body: JSON.stringify(data),
        })
          .then(checkHttpStatus)
          .then(parseJSON)
          .then((response) => {
            dispatch(passwordResetSuccess());
            if (callback) {
              callback();
            }
          })
          .catch((error) => {
            dispatch(passwordResetFailure());
            throw new SubmissionError({
              _error: 'Error submitting password reset:',
            });
          });
      });
  };
}

export function requestPasswordReset() {
  return {
    type: AUTH_PASSWORD_RESET_REQUEST,
  };
}

export function passwordResetSuccess() {
  return {
    type: AUTH_PASSWORD_RESET_SUCCESS,
  };
}

export function passwordResetFailure() {
  return {
    type: AUTH_PASSWORD_RESET_FAILURE,
  };
}

export function postSignupRequest() {
  return {
    type: AUTH_POST_SIGNUP_REQUEST,
  };
}

export function postSignupFailure(error) {
  return {
    type: AUTH_POST_SIGNUP_FAILURE,
    payload: {
      data: error,
    },
  };
}

export function postSignup(values, submitSuccessCallback) {
  const body = values;
  body.terms = values.terms ? 1 : 0;
  body.newsletter = values.newsletter ? 1 : 0;
  body.username = values.username;

  return (dispatch, getState) => {
    dispatch(postSignupRequest());
    dispatch(setAuthAction('signup'));
    const state = getState();
    const label = state.auth.provider ? state.auth.provider.name : 'Email';
    fbq('trackCustom', 'Registration', { provider: label });
    eventGA({
      category: 'Login and Signup',
      action: 'Signup Submit',
      label,
      dimension3: label,
      metric3: '1',
    });
    return fetch(`${SERVER_URL}/auth/register`, {
      method: 'post',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        if (response.status === 'success') {
          BrowserStore.set('token', response.data.token);
          dispatch(getAuthenticatedUserData(submitSuccessCallback));
        }
      })
      .catch((error) => {
        let errorParams = {
          _error: 'Connection Error: An error occurred while sending your data!',
        };
        errorParams = _.extend(errorParams, error.response);

        if (error.response && error.response.status === 400) {
          dispatch(postSignupFailure(error.response.statusText));
        } else {
          dispatch(
            postSignupFailure('An error occurred while trying to connect.'),
          );
        }

        eventGA({
          category: 'Login and Signup',
          action: 'Signup Fail',
          label,
          dimension3: `${label} - ${errorParams['_error']}`,
          metric2: '1',
        });

        initializeGTMWithEvent({
          event: 'signup',
          signupdata: {
            result: 'Failure',
            method: label,
            uid: null,
          },
        });

        throw new SubmissionError(errorParams);
      });
  };
}

export function socialLoginRequestAndSetProvider(provider) {
  return {
    type: AUTH_SOCIAL_LOGIN_REQUEST_AND_SET_PROVIDER,
    payload: {
      provider,
    },
  };
}

export function socialLoginOpenWindow(provider, removeModalCallback) {
  return (dispatch, getState) => {
    dispatch(socialLoginRequestAndSetProvider(provider));
    const state = getState();
    if (state.auth.provider) {
      const socialProvider = state.auth.provider;
      let socialWindow;

      if (socialProvider.openid.length > 0) {
        socialWindow = window.open(
          `${socialProvider.url +
          socialProvider.openid
          }`,
          null,
          `width=${socialProvider.width},height=${socialProvider.height}`,
        );
      } else {
        socialWindow = window.open(
          `${socialProvider.url}`,
          null,
          `width=${socialProvider.width},height=${socialProvider.height}`,
        );
      }
      // Use when switching to omega. Confirm and error needs to be fleshed out.
      let messagePoster = setInterval(() => {
        const message = '';
        if (socialWindow.closed) {
          messagePoster = null;
          return;
        }
        const expectedDomain = SERVER_OAUTH_URL.replace('/auth', '');
        socialWindow.postMessage(message, expectedDomain);
        window.addEventListener('message', (event) => {
          if (!event.origin.startsWith(expectedDomain)) return;
          if (event.data.action === 'success') {
            socialWindow.close();
            BrowserStore.set('token', event.data.token);
            dispatch(setAuthAction('login'));
            dispatch(getAuthenticatedUserData(removeModalCallback));
          } else if (event.data.action === 'confirm') {
            socialWindow.close();
            dispatch(setAuthAction('signup'));
            dispatch(handleConfirmRedirect(event.data.user));
            modal.clear();
            modal.add(SignUpModalView, { hideTitleBar: true, size: 'medium', id: 'signup-confirm' });
          } else if (event.data.status === 'error') {
            eventGA({
              category: 'Login and Signup',
              action: 'Login Fail',
              label: state.auth.provider.name,
              dimension3: state.auth.provider.name,
              metric5: '1',
            });
            // console.error(event.data);
            socialWindow.close();
            // Error actions
          }
        }, false);
      }, 6000);
    }
    return {
      type: AUTH_OPEN_SOCIAL_WINDOW,
    };
  };
}

export function handleConfirmRedirect(data) {
  return {
    type: AUTH_HANDLE_CONFIRM_REDIRECT,
    payload: {
      data,
    },
  };
}

export function fetchLogin(values, redirect = '/', removeModal) {
  return (dispatch) => {
    dispatch(authLoginUserRequest());
    dispatch(setAuthAction('login'));
    eventGA({
      category: 'Login and Signup',
      action: 'Login Submit',
      label: 'Email',
      dimension3: 'Email',
      metric6: '1',
    });
    return fetch(`${SERVER_URL}/auth/login`, {
      method: 'post',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(values),
    })
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        if (response.status === 'success') {
          if (response.token) {
            BrowserStore.set('token', response.token);
            dispatch(getAuthenticatedUserData(removeModal));
          }
        }
      })
      .catch((error) => {
        dispatch(authLoginUserFailure('Login Error!', error.message));
        let errorParams = {
          _error: (error.response && error.response.status_code === 403) ? 'Incorrect email or password.'
            : 'Connection Error: An error occurred while sending your data!',
        };
        errorParams = _.extend(errorParams, error.response);

        eventGA({
          category: 'Login and Signup',
          action: 'Login Fail',
          label: 'Email',
          dimension3: `Email - ${errorParams['_error']}`,
          metric6: '1',
        });


        throw new SubmissionError(errorParams);

        return Promise.resolve(); // TODO: we need a promise here because of the tests, find a better way
      });
  };
}

export function getAuthenticatedUserData(callback) {
  return (dispatch) => {
    return ExploreAuth.getValidJwt()
      .then((tokenIsValid) => {
        // Token can't be refreshed log them out
        if (!tokenIsValid) {
          // We should probably add a modal here informing them they need to log back in.
          dispatch(authLogout());
        }
        return fetch(`${SERVER_URL}/auth/get_authenticated_user_info`, {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'x-www-form-urlencoded',
            Authorization: `Bearer ${ExploreAuth.getJwt()}`,
          },
        })
          .then(checkHttpStatus)
          .then(parseJSON)
          .then((userResponse) => {
            dispatch(authLoginUserSuccess(userResponse.data));
            dispatch(setUserPreferences(userResponse.data.preferences));
            dispatch(fetchUserFavoritesSuccess(userResponse.data.favorites));
            dispatch(setInitialLoad(true));
            if (callback) callback();
          });
      });
  };
}

export function disableRegistrationPrompt() {
  return { type: DISABLE_REGISTRATION_PROMPT };
}

export function authLoginUserSuccess(data) {
  return (dispatch, getState) => {
    const state = getState();
    BrowserStore.session.set('user', data);
    setDataGA({ userId: data.user_id });
    dataLayerGTM({ dataLayer: { uid: data.user_id }});
    // This only exists to get the snapshot dashbord to handle logins
    const loginSuccessful = new CustomEvent('loginSuccessful');
    window.dispatchEvent(loginSuccessful);
    dispatch(disableRegistrationPrompt());
    dispatch(currentUserSuccess(data));
    const label = state.auth.provider ? state.auth.provider.name : 'Email';
    dataLayerGTM({ uid: data.user_id });
    if (state.auth.action === 'login') {
      eventGA({
        category: 'Login and Signup',
        action: 'Login Success',
        label,
        dimension1: data.user_id,
        dimension2: 'Yes',
        dimension3: label,
        metric4: '1',
      });
      initializeGTMWithEvent({
        event: 'login',
        logindata: {
          result: 'Success',
          method: label,
          uid: data.user_id,
        },
      });
    }

    if (state.auth.action === 'signup') {
      eventGA({
        category: 'Login and Signup',
        action: 'Signup Success',
        label,
        dimension1: data.user_id,
        dimension2: 'Yes',
        dimension3: label,
        metric1: '1',
      });

      initializeGTMWithEvent({
        event: 'signup',
        signupdata: {
          result: 'Success',
          method: label,
          uid: data.user_id,
        },
      });
    }

    return dispatch({
      type: AUTH_LOGIN_USER_SUCCESS,
      payload: { user: data },
    });
  };
}

export function authLoginUserFailure(error, message) {
  BrowserStore.session.remove('token');
  BrowserStore.remove('janrain');
  BrowserStore.remove('user');
  BrowserStore.remove('associate');
  BrowserStore.remove('token');
  return {
    type: AUTH_LOGIN_USER_FAILURE,
    payload: {
      status: error,
      statusText: message,
    },
  };
}

export function authLoginUserRequest() {
  return {
    type: AUTH_LOGIN_USER_REQUEST,
  };
}

export function unsetJanrain() {
  return {
    type: UNSET_JANRAIN,
    payload: {
      janrain: null,
    },
  };
}

export function authLogoutAndRedirect() {
  return (dispatch) => {
    return ExploreAuth.getValidJwt()
      .then((tokenIsValid) => {
        // Token can't be refreshed log them out
        if (!tokenIsValid) {
          // We should probably add a modal here informing them they need to log back in.
          dispatch(authLogout());
        }
        return fetch(`${SERVER_URL}/auth/logout`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${ExploreAuth.getJwt()}`,
          },
        })
          .then(checkHttpStatus)
          .then(parseJSON)
          .then(() => {
            dispatch(authLogout());
          })
          .catch((err) => {
            console.error('Look, it\'s not you; It\'s me; but I need you to log back in.', err);
            dispatch(authLogout());
          });
      });
  };
}

export function deleteUserRequest() {
  return {
    type: AUTH_DELETE_USER_REQUEST,
  };
}
export function deleteUserSuccess() {
  BrowserStore.session.set('user_deleted', true);
  return {
    type: AUTH_DELETE_USER_SUCCESS,
  };
}
export function deleteUserFailure() {
  return {
    type: AUTH_DELETE_USER_FAILURE,
  };
}

export function authDeleteUser() {
  return (dispatch) => {
    dispatch(deleteUserRequest());
    return ExploreAuth.getValidJwt()
      .then((tokenIsValid) => {
        // Token can't be refreshed log them out
        if (!tokenIsValid) {
          // We should probably add a modal here informing them they need to log back in.
          dispatch(authLogout());
        }
        return fetch(`${SERVER_URL}/user/delete`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${ExploreAuth.getJwt()}`,
          },
        })
          .then(checkHttpStatus)
          .then(parseJSON)
          .then(() => {
            dispatch(deleteUserSuccess());
            dispatch(authLogout());
          })
          .catch((err) => {
            dispatch(deleteUserFailure());
          });
      });
  };
}

// Actions for handling the association of a user to a social account
export function authAssociateUserRequest() {
  return {
    type: AUTH_ASSOCIATE_USER_REQUEST,
  };
}

export function authAssociateUserFailure() {
  return {
    type: AUTH_ASSOCIATE_USER_FAILURE,
  };
}

export function authAssociateUserSuccess() {
  return {
    type: AUTH_ASSOCIATE_USER_SUCCESS,
  };
}

export function authAssociateUser(email, password, removeModal) {
  return (dispatch) => {
    dispatch(authAssociateUserRequest());
    return fetch(`${SERVER_URL}/auth/associate`, {
      method: 'post',
      credentials: 'same-origin',
      mode: 'same-origin',
      headers: {
        'Content-Type': 'x-www-form-urlencoded',
      },
      body: encodeURI(`email=${email}&password=${password}`),
    })
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        removeModal();
        dispatch(authAssociateUserSuccess(response.data));
        dispatch(authLoginUserSuccess(response.data));
        dispatch(fetchUserFavoritesSuccess(response.data.favorites));
        dispatch(setUserPreferences(response.data.preferences));
      })
      .catch((error) => {
        let errorParams = {
          _error: 'Connection Error: An error occurred while sending your data!',
        };
        errorParams = _.extend(errorParams, error.response);
        dispatch(authAssociateUserFailure());
        throw new SubmissionError(errorParams);
      });
  };
}


// This and LoginView may not be used anymore.
export function authLoginUser(email, password, redirect = '/') {
  return (dispatch) => {
    dispatch(authLoginUserRequest());
    const auth = btoa(`${email}:${password}`);
    return fetch(`${SERVER_URL}/api/v1/accounts/login/`, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Basic ${auth}`,
      },
    })
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(authLoginUserSuccess(response.token, response.user));
        dispatch(push(redirect));
      })
      .catch((error) => {
        if (
          error &&
          typeof error.response !== 'undefined' &&
          error.response.status === 401
        ) {
          // Invalid authentication credentials
          return error.response.json()
            .then((data) => {
              dispatch(authLoginUserFailure(401, data.non_field_errors[0]));
            });
        } else if (
          error &&
          typeof error.response !== 'undefined' &&
          error.response.status === 403
        ) {
          // Invalid authentication credentials
          return error.response.json()
            .then((data) => {
              dispatch(authLoginUserFailure(403, 'Incorrect email or password.'));
            });
        } else if (
          error &&
          typeof error.response !== 'undefined' &&
          error.response.status >= 500
        ) {
          // Server side error
          dispatch(
            authLoginUserFailure(
              500,
              'A server error occurred while sending your data!',
            ),
          );
        } else {
          // Most likely connection issues
          dispatch(
            authLoginUserFailure(
              'Connection Error',
              'An error occurred while sending your data!',
            ),
          );
        }

        return Promise.resolve(); // TODO: we need a promise here because of the tests, find a better way
      });
  };
}

export function disqusReset() {
  if (
    typeof DISQUS !== 'undefined' &&
    document.getElementById('disqus_thread')
  ) {
    DISQUS.reset({
      reload: true,
      config() {
        this.page.remote_auth_s3 = null;
      },
    });
  }
  return {
    type: AUTH_DISQUS_RESET,
  };
}

export function disqusSetSSO(disqus_sso) {
  return {
    type: AUTH_DISQUS_SET,
    payload: { disqus_sso },
  };
}

export function disqusCheckAndRefreshSSO() {
  return (dispatch, getState) => {
    const state = getState();
    // Check there is a logged in user
    if (!state.auth.userId) {
      return Promise.resolve();
    }
    let { disqus_sso } = state.auth;
    if (disqus_sso) {
      const disqusExpTime = disqus_sso.split(' ')
        .slice(-1)
        .pop();
      if (!isNaN(disqusExpTime)) {
        const now = new Date();
        const expiration = new Date(0);
        expiration.setUTCSeconds(disqusExpTime);
        // Comments token expires 2 hours after creation.
        expiration.setHours(expiration.getHours() + 2);
        // If it isnt' expiring within the next 30 minutes, lets be on our way.
        if (expiration.getTime() > new Date(now.getTime() + (30 * 60000))) {
          return Promise.resolve();
        }
      }
    }
    const token = ExploreAuth.getJwt();
    if (!token) return Promise.resolve();
    return fetch(`${SERVER_URL}/user_disqus_token`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'x-www-form-urlencoded',
        Authorization: `Bearer ${token}`,
      },
    })
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const { disqus_sso } = response.data;
        return dispatch(disqusSetSSO(disqus_sso));
      })
      .catch(err => console.error(err));
  };
}

export function subscribeToNewsletter(values) {
  return (dispatch) => {
    dispatch(authLoginUserRequest());
    return fetch(`${SERVER_URL}/auth/newsletter_subscribe`, {
      method: 'post',
      headers: {
        Accept: 'application/json, text/javascript, */*; q=0.01',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: queryString.stringify(values),
    })
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        // Success response
      })
      .catch((error) => {
        let errorParams = {
          _error: 'Connection Error: An error occurred while sending your data!',
        };
        errorParams = _.extend(errorParams, error.response);

        throw new SubmissionError(errorParams);

        return Promise.resolve(); // TODO: we need a promise here because of the tests, find a better way
      });
  };
}

export function checkToken(token) {
  return (dispatch) => {
    return fetch(`${SERVER_URL}/accounts/check_token.json`, {
      method: 'post',
      headers: {
        Accept: 'application/json, text/javascript, */*; q=0.01',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: queryString.stringify({ token }),
    })
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(setResetToken(token));
      })
      .catch((error) => {
        const alerts = _.get(error, 'response.data.alerts', []);
        dispatch(setAlerts(alerts));
        dispatch(clearResetToken());
        browserHistory.push('/livecams');
      });
  };
}

export function setResetToken(token) {
  return {
    type: AUTH_SET_RESET_TOKEN,
    payload: { token },
  };
}

export function clearResetToken() {
  return {
    type: AUTH_CLEAR_RESET_TOKEN,
  };
}

export function fetchAndSetCamerasApiToken(token) {
  return (dispatch) => {
    return fetch(`${SERVER_URL}/cameras/token`)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const token = response.data.token;
        dispatch(setCamerasToken(token));
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function setCamerasToken(token) {
  return {
    type: AUTH_SET_CAMERAS_API_TOKEN,
    payload: { token },
  };
}

export function setUserRatedSnapshots(ratings) {
  return {
    type: AUTH_SET_SNAPSHOT_RATINGS,
    payload: { ratings },
  };
}

export function requestBroadcast() {
  return {
    type: AUTH_BROADCAST_REQUEST,
  };
}

export function broadcastSuccess(template) {
  return {
    type: AUTH_BROADCAST_SUCCESS,
    payload: { template },
  };
}

export function broadcastFailure() {
  return {
    type: AUTH_BROADCAST_FAILURE,
  };
}

export function requestTemplate() {
  return {
    type: AUTH_TEMPLATE_REQUEST,
  };
}

export function templateSuccess(data) {
  return {
    type: AUTH_TEMPLATE_SUCCESS,
    payload: data,
  };
}

export function templateFailure() {
  return {
    type: AUTH_TEMPLATE_FAILURE,
  };
}

export function sendBroadcastRequest(formData, callback) {
  return (dispatch) => {
    const data = {
      description: formData.description,
      fb_page: formData.fb_page,
      duration: formData.duration,
      stream_id: isSubdomain ? 36 : formData.streamId,
    };
    dispatch(requestBroadcast());
    return ExploreAuth.getValidJwt()
      .then((tokenIsValid) => {
        // Token can't be refreshed log them out
        if (!tokenIsValid) {
          // We should probably add a modal here informing them they need to log back in.
          dispatch(authLogout());
        }
        return fetch(`${SERVER_URL}/broadcast/facebook`, {
          method: 'post',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${ExploreAuth.getJwt()}`,
          },
          body: JSON.stringify(data),
        })
          .then(checkHttpStatus)
          .then(parseJSON)
          .then((response) => {
            dispatch(broadcastSuccess());
            if (callback) {
              callback();
            }
          })
          .catch((error) => {
            dispatch(broadcastFailure());
            throw new SubmissionError({
              _error: 'Error submitting broadcast request:',
            });
          });
      });
  };
}

export function sendTemplateRequest(id, callback) {
  return (dispatch) => {
    const streamId = isSubdomain ? 36 : id;
    dispatch(requestTemplate());
    return ExploreAuth.getValidJwt()
      .then((tokenIsValid) => {
        // Token can't be refreshed log them out
        if (!tokenIsValid) {
          // We should probably add a modal here informing them they need to log back in.
          dispatch(authLogout());
        }
        return fetch(`${SERVER_URL}/broadcast/templates?id=${streamId}`, {
          method: 'get',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${ExploreAuth.getJwt()}`,
          },
        })
          .then(checkHttpStatus)
          .then(parseJSON)
          .then((response) => {
            dispatch(templateSuccess(response.data));
            if (callback) {
              callback();
            }
          })
          .catch((error) => {
            dispatch(templateFailure());
            console.log(error);
            // throw new SubmissionError({
            //   _error: 'Error submitting broadcast request:',
            // });
          });
      });
  };
}

export function sendPlayerAlertRequest() {
  return {
    type: AUTH_PLAYER_ALERT_REQUEST,
  };
}

export function sendPlayerAlertSuccess(data) {
  return {
    type: AUTH_PLAYER_ALERT_SUCCESS,
    payload: data,
  };
}

export function sendPlayerAlertFailure() {
  return {
    type: AUTH_PLAYER_ALERT_FAILURE,
  };
}

export function sendNewPlayerAlertRequest(formData, callback) {
  return (dispatch) => {
    const data = {
      message: formData.message,
      livecamId: formData.livecamId,
      duration: formData.duration,
    };
    dispatch(sendPlayerAlertRequest());
    return ExploreAuth.getValidJwt()
      .then((tokenIsValid) => {
        // Token can't be refreshed log them out
        if (!tokenIsValid) {
          // We should probably add a modal here informing them they need to log back in.
          dispatch(authLogout());
        }
        return fetch(`${SERVER_URL}/broadcast/player-alert`, {
          method: 'post',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${ExploreAuth.getJwt()}`,
          },
          body: JSON.stringify(data),
        })
          .then(checkHttpStatus)
          .then(parseJSON)
          .then((response) => {
            dispatch(sendPlayerAlertSuccess());
            if (callback) {
              callback();
            }
          })
          .catch((error) => {
            dispatch(sendPlayerAlertFailure());
            throw new SubmissionError({
              _error: 'Error submitting broadcast request:',
            });
          });
      });
  };
}
